import { useState } from "react";
import StatusIcons from "../../../Components/StatusIcons/StatusIcons";
import ActionDropDown from "../../Shipper/Customer/MainPages/Shipments/Components/TicketCreateModal/ActionDropDown/ActionDropDown";
import CircularLoader from "../../../Components/CircularLoader/CircularLoader";
import { convertTime } from "../../../helpers/helpers";
import { useTranslation } from "react-i18next";

const Columns = ({
  setSelectDriverModal,
  setInvoiceModal,
  drivers,
  setShipmentStatusModal,
}) => {
  const { t } = useTranslation("carrier");
  const [labelDownloading, setLabelDownloading] = useState("");

  const printLabel = async (row) => {
    setLabelDownloading("label" + row?.id);
    try {
      fetch(row?.single_shipping_labels.file, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      })
        .then((url) => url.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${row.tattension + " " + row.shipment_tracking_id} Label.pdf`
          );
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLabelDownloading("");
        });
    } catch (error) {
      setLabelDownloading("");
    }
  };
  return [
    {
      id: 1,
      label: "#",
      render: (row) => <>{row?.id ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 2,
      label: t("dispatcher.client"),
      render: (row) => <>{row?.user?.username ?? "-"}</>,
      width: "200px",
      fixed: "left",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 3,
      label: t("dispatcher.service"),
      render: (row) => <>{row?.service_type ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 4,
      label: t("dispatcher.status"),
      render: (row) => {
        return <StatusIcons status={row.shipment_status ?? "N/A"} />;
      },
      width: "200px",
      disabled: (row) => row?.shipment_status === "Cancelled",
    },
    // {
    //   id: 5,
    //   label: "Reference ID",
    //   render: (row) => <>{row?.referance_code ?? "-"}</>,
    //   width: "200px",
    //   disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    // },
    {
      id: 6,
      label: t("dispatcher.boltTrackingId"),
      render: (row) => <>{row?.tracking_id ?? "-"}</>,
      width: "300px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 7,
      label: t("dispatcher.carrierTrackingId"),
      render: (row) => <>{row?.shipment_tracking_id ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 8,
      label: t("dispatcher.pickupId"),
      render: (row) => <>{row?.PickupID ?? "N/A"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 9,
      label: t("dispatcher.pickup"),
      render: (row) => (
        <>
          {" "}
          {row.PickupDate &&
            `${row.PickupDate?.slice(0, 10)}  ${
              row.readyopentime ? row.readyopentime?.slice(0, 5) : ""
            }${row.readyopentime && row.readyclosetime ? "-" : ""}${
              row.readyclosetime ? row.readyclosetime?.slice(0, 5) : ""
            }`}
          {!row.PickupDate && <>N/A</>}
        </>
      ),
      width: "250px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 10,
      label: t("dispatcher.estDeliveryDate"),
      render: (row) => <>{row?.estimated_delivery_date?.slice(0, 10) ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    // {
    //   id: 11,
    //   label: "Payment Status",
    //   render: (row) => {
    //     return <StatusIcons status={row.payment_status ?? "Paid"} />;
    //   },
    //   width: "200px",
    //   disabled: (row) => row?.shipment_status === "Cancelled",
    // },
    {
      id: 12,
      label: t("dispatcher.weight"),
      render: (row) => <>{row?.total_weight ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    // {
    //   id: 13,
    //   label: "Volume",
    //   render: (row) => <>{row?.volume ?? "-"}</>,
    //   width: "140px",
    //   disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    // },

    {
      id: 14,
      label: t("dispatcher.pickupCity"),
      render: (row) => <>{row?.fcity ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 15,
      label: t("dispatcher.pickupAddress"),
      render: (row) => (
        <>
          <div className="content__wrapping_boltTable">
            {row?.faddress ?? "-"}
          </div>
        </>
      ),
      width: "300px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 16,
      label: t("dispatcher.deliveryCity"),
      render: (row) => <>{row?.tcity ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 17,
      label: t("dispatcher.deliveryAddress"),
      render: (row) => (
        <>
          <div className="content__wrapping_boltTable">
            {row?.taddress ?? "-"}
          </div>
        </>
      ),
      width: "300px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 18,
      label: t("dispatcher.customerName"),
      render: (row) => <>{row?.tattension ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 19,
      label: t("dispatcher.pickupNotes"),
      render: (row) => <>{row?.finstructions ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 20,
      label: t("dispatcher.total"),
      render: (row) => <>{row?.Total ?? "-"}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },

    {
      id: 21,
      label: t("dispatcher.pickupDriver"),
      render: (row) => (
        <div
          onClick={() =>
            setSelectDriverModal({
              shipmentId: row.id,
              type: "delivery",
              ...row,
            })
          }
          className="cursor-pointer"
        >
          {row.pickup_driver &&
          drivers?.find((driver) => driver?.id === parseInt(row.pickup_driver))
            ?.name ? (
            <>
              {
                drivers?.find(
                  (driver) => driver?.id === parseInt(row.pickup_driver)
                )?.name
              }
            </>
          ) : (
            <div className="text-ui-text-subtle">{t("dispatcher.notAssigned")}</div>
          )}
        </div>
      ),
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 22,
      label: t("dispatcher.deliveryDriver"),
      render: (row) => (
        <div
          onClick={() =>
            setSelectDriverModal({
              shipmentId: row.id,
              type: "delivery",
              ...row,
            })
          }
          className="cursor-pointer"
        >
          {row.delivery_driver &&
          drivers?.find(
            (driver) => driver?.id === parseInt(row.delivery_driver)
          )?.name ? (
            <>
              {
                drivers?.find(
                  (driver) => driver?.id === parseInt(row.delivery_driver)
                )?.name
              }
            </>
          ) : (
            <div className="text-ui-text-subtle">{t("dispatcher.notAssigned")}</div>
          )}
        </div>
      ),
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 23,
      label: t("dispatcher.createdAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
    {
      id: 24,
      label: t("dispatcher.actions"),
      render: (row) => (
        <>
          <ActionDropDown
            row={row}
            setInvoiceModal={setInvoiceModal}
            printLabel={printLabel}
            labelDownloading={labelDownloading}
            CircularLoader={CircularLoader}
            setDriverModal={() =>
              setSelectDriverModal({
                shipmentId: row.id,
                type: "delivery",
                ...row,
              })
            }
            setShipmentStatusModal={setShipmentStatusModal}
          />
        </>
      ),
      width: "350px",
      fixed: "right",
      disabled: (row) => (row?.shipment_status === "Cancelled" ? true : false),
    },
  ];
};

export default Columns;
